import { lazy, Suspense, useMemo } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
} from "react-router-dom";
import Header from "./Layout/Ar/Header";
import LandingPage from "./Components/LandingPage/LandingPage";
import LazyBottomMenu from './Components/LazyBottomMenu';
import LazyFeedbackButton from './Components/LazyFeedbackButton';
import { humanRoutes } from "./routes/humanRoutes";
import { healthRoutes } from "./routes/healthRoutes";
import { islamicRoutes } from "./routes/islamicRoutes";
import { womenRoutes } from "./routes/womenRoutes";
import { mathRoutes } from "./routes/mathRoutes";
import { physicsRoutes } from "./routes/physicsRoutes";
import { otherRoutes } from "./routes/otherRoutes";
import { financialRoutes } from "./routes/financialRoutes.js";
import { articlesRoutes } from "./routes/articlesRoutes.js";
import { studyRoutes } from "./routes/studyRoutes.js";
import { chemistryRoutes } from "./routes/chemistryRoutes.js";
import { unitRoutes } from "./routes/unitRoutes.js";
import { foodRoutes } from "./routes/foodRoutes.js";
import { mainRoutes } from "./routes/mainRoutes.js";
import { allFrenchRoutes } from "./routes/frenchRoutes.js";
import NotFound from "./Components/NotFound.js";

const LandingPageEN = lazy(() => import("./Components/LandingPageEN/LandingPage"));
const LandingPageFr = lazy(() => import("./Components/LandingPageFr/LandingPage"));
const LandingPageId = lazy(() => import("./Components/LandingPageId/LandingPage"));
const Privacy = lazy(() => import("./Components/Ar/Policy"));
const HeaderEN = lazy(() => import("./Layout/EN/Header"));
const HeaderFr = lazy(() => import("./Layout/Fr/Header"));
const HeaderId = lazy(() => import("./Layout/Id/Header"));

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
const allRoutes = [
  ...mainRoutes,
  ...humanRoutes,
  ...healthRoutes,
  ...islamicRoutes,
  ...womenRoutes,
  ...mathRoutes,
  ...physicsRoutes,
  ...otherRoutes,
  ...financialRoutes,
  ...articlesRoutes,
  ...studyRoutes,
  ...chemistryRoutes,
  ...unitRoutes,
  ...foodRoutes,
  ...allFrenchRoutes,
];

function AppContent() {
  const location = useLocation();
const currentLanguage = location.pathname.includes("/en/") || location.pathname.startsWith("/articles-en/")
    ? "en"
    : location.pathname.includes("/fr/") || location.pathname.startsWith("/articles-fr/")
    ? "fr" 
    : location.pathname.includes("/id/") || location.pathname.startsWith("/articles-id/")
    ? "id"
    : "ar";
  
  const HeaderComponent = useMemo(() => {
    switch(currentLanguage) {
      case "en":
        return HeaderEN;
      case "fr":
        return HeaderFr;
      case "id":
        return HeaderId;
      default:
        return Header;
    }
  }, [currentLanguage]);
  return (
    <>
      <div >
        <HeaderComponent isEnglish={currentLanguage === "en"} />
      </div>
      <div className="container" >

        <Routes>
          <Route element={<Suspense fallback={<div className="page-loader">Loading...</div>}><Outlet /></Suspense>}>
            {allRoutes.map((route) => (
              <Route key={route.path} path={route.path} element={<route.component />} />
            ))}
            {/* English routes */}
            <Route path="/en/" element={<LandingPageEN />} />
            {/* Arabic privacy */}
            <Route path="/ar/privacy/" element={<Privacy />} />
            {/* French landing page */}
            <Route path="/fr/" element={<LandingPageFr />} />
            {/* Indonesian landing page */}
            <Route path="/id/" element={<LandingPageId />} />
          </Route>
          <Route path="/" element={<LandingPage />} />
          <Route path="/ar/" element={<LandingPage />} />
          <Route path="*" element={
            <Suspense fallback={<div>Loading...</div>}>
              <NotFound />
            </Suspense>
          } />
        </Routes>
        <LazyFeedbackButton />
        <LazyBottomMenu />
      </div>
    </>
  );
}
export default App;
